// simplified version of Element matches polyfill that supports only modern browser (ie 11+)
export default (() => {
  if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.matchesSelector ||
        Element.prototype.mozMatchesSelector ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.oMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
  }
})();



// WEBPACK FOOTER //
// ./src/scripts/utils/element.matches.polyfill.js